import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  justify-content: center;
  align-items: flex-start;
`;

export const TitleForm = styled.h2`
  font-size:20px;
  font-weight: bold;
  color: ${theme.colors.black};
`;

export const Row = styled.div`
  width: 100%;
`;
